import { render, staticRenderFns } from "./KaipiaoApply.vue?vue&type=template&id=728f3272&scoped=true&"
import script from "./KaipiaoApply.vue?vue&type=script&lang=js&"
export * from "./KaipiaoApply.vue?vue&type=script&lang=js&"
import style0 from "./KaipiaoApply.vue?vue&type=style&index=0&id=728f3272&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728f3272",
  null
  
)

export default component.exports